export const CONFIRMATION_DIALOG_ID_PREFIX = 'confirmation_dialog_button'
